import API from "../modules/admin/api/nsi";
import axios from "axios";
import L from 'leaflet';

export default {
  loadSelectOptions(dictName, optionsArray, requestData, isClear) {
    API.getNsi(dictName, requestData).then(function (response) {
      if (isClear) {
        while (optionsArray.length > 1) optionsArray.pop();
      }

      if (response.data && response.data.length) {
        response.data.forEach((i) => optionsArray.push(i));
      }
    });
  },
  downloadFileByUid(uid, filename) {
    return this.downloadFile(`/api/file/downloadByGuid?guid=${uid}`, filename);
  },
  downloadFile(url, filename, params) {
    var options = { responseType: 'blob'};
    if (params) {
      options.params = params;
    }
    return axios.get(url, options)
      .then(response => {
        const blob = new Blob([response.data], { type: response.data.type });
        const link = document.createElement('a');
        const contentDisposition = response.headers['content-disposition'];
        // if (contentDisposition) {
        //   const matches = contentDisposition.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?/);
        //   if (matches.length === 2) {
        //     console.log(matches[1]);
        //     filename = matches[1];
        //   }
        // }

        if (contentDisposition) {
          // Пытаемся взять filename*=
          let utfFilename = contentDisposition.match(/filename\*=([^;]+)/);
          if (utfFilename && utfFilename[1]) {
            const value = utfFilename[1].trim();
            // формат RFC 5987: UTF-8''%D0...
            const parts = value.split("''");
            if (parts.length === 2) {
              filename = decodeURIComponent(parts[1]);
            }
          } else {
            // Иначе обычный filename=""
            let asciiFilename = contentDisposition.match(/filename="(.+?)"/);
            if (asciiFilename && asciiFilename[1]) {
              filename = asciiFilename[1];
            }
          }
        }

        link.href = URL.createObjectURL(blob);
        link.download = filename || 'download';
        link.click();
        URL.revokeObjectURL(link.href);
      });
  },
  getMarkerIcon(kindActivityId, isTemp) {
    var folder = isTemp ? "map" : "map/color";
    return L.icon({
      iconUrl: require(`@/assets/${folder}/marker${(kindActivityId ? kindActivityId : 0)}.png`),
      iconSize: [48 * 0.75, 56 * 0.75],
      iconAnchor: [48 * 0.5 * 0.75, 56 * 0.75]
    });
  },
  getServiceWordByCount(count) {
    console.log(count * 1, "-- getServiceWordByCount");
    if (count >= 5 & count <= 20) 
      return "услуг";
    if(count % 10 == 1)
      return "услуга";
    if (count % 10 == 2 || count % 10 == 3 || count % 10 == 4)
      return "услуги";
  
    return "услуг";
  },
  
  enToRu(text) {
      const map = {
        q: 'й', w: 'ц', e: 'у', r: 'к', t: 'е',
        y: 'н', u: 'г', i: 'ш', o: 'щ', p: 'з',
        '[': 'х', ']': 'ъ',

        a: 'ф', s: 'ы', d: 'в', f: 'а', g: 'п',
        h: 'р', j: 'о', k: 'л', l: 'д', ';': 'ж',
        "'": 'э',

        z: 'я', x: 'ч', c: 'с', v: 'м', b: 'и',
        n: 'т', m: 'ь', ',': 'б', '.': 'ю'
      };

      return text
        .split('')
        .map(ch => {
          const lower = ch.toLowerCase();
          const ru = map[lower];

          if (!ru) {
            return ch;
          }

          return ch === lower
            ? ru
            : ru.toUpperCase();
        })
        .join('');
  },
}